// @flow
import React from 'react';
import { asyncPaymentRedirectToOrderPage } from '../../duck';

import type { Node } from 'react';
import type { Order } from '../../../../../entities';
import type { ImplementationType, PaymentImpl } from '../index';
import type { BillingAddressReq } from '../../api';
import type { RootState } from '../../../../index';

export default class SafetyPayPayment implements PaymentImpl {
  type: ImplementationType = 'safetypay';
  order: Order;
  dispatch: Function;
  // Custom safety properties
  safetyWindow: any;

  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    this.dispatch = dispatch;
  }

  generateCustomUI = (): Node => undefined;

  executeUIAction(billingAddress: BillingAddressReq, rootState: RootState) {
    const order = this.order;
    this.safetyWindow = window.open('', 'Pagar con Safetypay', 'width=850,height=500');
    if (this.order.invoice.payment.paymentData.shopperRedirectUrl) {
      this.showPopUp(this.order.invoice.payment.paymentData.shopperRedirectUrl);
      this.dispatch(asyncPaymentRedirectToOrderPage(order));
    }
  };

  showPopUp(data: string) {
    this.safetyWindow = window.open('', 'Pagar con Safetypay', 'width=850,height=500');
    this.safetyWindow.location = data;
    this.safetyWindow.focus();
  }

  clean = () => {
    if (this.safetyWindow) {
      this.safetyWindow.close();
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/SafetyPay/index.js